module.exports = __webpack_public_path__ + "img/logo2.77c39841.png";